<p-dialog header="Êtes vous toujours là ?" [(visible)]="display"  [closable]="false" [modal]="true" [responsive]="true" [style]="{width: '550px', minWidth: '200px'}" [minY]="70" 
         [baseZIndex]="10000">
          
      <div class="row">
        <br>  
             <p>
              Dans {{remainingTime}} secondes votre session atteindra sa limite de {{timeout / 60000}} minutes.  
              Afin de garantir la sécurité de votre compte, vous serez automatiquement déconnecté(e).
              Vous pouvez choisir de prolonger votre session ci-dessous.
             </p>
        <br>
      </div>
        <p-footer>         
          <div class="bco-grid-tools d-flex justify-content-end">  
              <div class="item mr-2" style="font-weight: normal;"> 
                <a (click)="disconnect()">Me déconnecter</a>
              </div>
              
              <div class="item" style="font-weight: normal;"> 
                <a (click)="continue()">Continuer sur Coffre-fort </a>
              </div>
          </div> 
        </p-footer>
</p-dialog>
<body id="page-top">
  <app-nav-menu *ngIf="headerVisible"></app-nav-menu>
  <div [ngClass]="{ 'app-body':!IsloginPage && !IslikeloginPage}">
    <div [ngClass]="{ 'app-container': !IsloginPage && !IslikeloginPage}">
      <div class="bco-breadcrumb" *ngIf="headerVisible">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <app-loader></app-loader>
      <app-error></app-error>
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="!IslikeloginPage && !IsloginPage"></app-footer>
  </div>
  <a *ngIf="!IslikeloginPage  && !IsloginPage" class="border rounded d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
</body>
